import { get } from "lodash";
import { bool, func, object } from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { isAdPosition } from "../utils/story";
import { getQueryParamsForArticleApi } from "../utils/utils";
import AdWrapper from "./atoms/AdWrapper";

export const WithStoryAds = ({ counter = {}, componentToRender, story }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], {}));
  let sectionName = currentPath.split("?")[0].split("/")[1];
  let pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", sectionName], "sections")
  );
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  let storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_Article/gulfnews_sections_article/gulfnews_sections_article_`;
  const params = getQueryParamsForArticleApi(currentPath);
  if (params.articleApi) {
    storyPageAdUnit = `/${networkId}/GULFNEWS/Gulfnews_App/gulfnews_newapp_articles/gulfnews_newapp_articles_inarticle`;
  }
  const adsConfig = get(qtState, ["config", "ads-config"], {});

  const storyPageLhsAd = get(adsConfig, ["slots", "story_page_lhs_ad_1"], {});

  const noAds = get(qtState, ["config", "noAds"], false);

  counter.paragraphs++;
  const showAd = isAdPosition(counter);
  if (showAd) {
    counter.ads++;
  }

  return (
    <>
      {componentToRender}
      {showAd && !noAds && (
        <AdWrapper
          adStyleName="story-page-ad-slot"
          id={`story-paragraph-ad-${story?.id}-${counter.ads}`}
          path={`${storyPageAdUnit}${counter.ads}`}
          size={storyPageLhsAd.sizes}
          viewPortSizeMapping={storyPageLhsAd.view_port_size_mapping}
          isLhsAd={true}
          count={counter.ads}
        />
      )}
    </>
  );
};

WithStoryAds.propTypes = {
  counter: object,
  story: object,
  showAd: bool,
  isParagraph: bool,
  componentToRender: func,
};
